<script>
export default {
    name: 'IlluGestionCentre',
    props: {
        primaryColor: {
            type: String,
            default: '#31A4A7'
        },

        secondaryColor: {
            type: String,
            default: '#313132'
        },
    }
}
</script>
<template>
    <svg
        class="base-illu illu-gestion_centre"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g fill="none" fill-rule="evenodd">
            <path
                d="M32 18.628l-9.5 7.22V55.5h19V25.848l-9.5-7.22z"
                :stroke="secondaryColor" class="secondary-color"
            />
            <path
                d="M35.5 44.5h-7v11h7v-11zM37.5 36.5h-11v3h11v-3zM52.5 38.5h-8v4h8v-4zM52.5 46.5h-8v4h8v-4zM19.5 38.5h-8v4h8v-4zM19.5 46.5h-8v4h8v-4z"
                :stroke="secondaryColor" class="secondary-color"
            />
            <path
                d="M41.5 28.833V55.5h14V36.3l-14-7.467zM22.5 28.833L8.5 36.3v19.2h14V28.833z"
                :stroke="secondaryColor" class="secondary-color"
            />
            <path :fill="secondaryColor" class="secondary-color" d="M32 8h1v11h-1z" />
            <path
                d="M32 24c1.657 0 3 1.25 3 2.793V33h-2.166v-2.483h-1.667V33H29v-6.207C29 25.25 30.343 24 32 24zm0 2.017c-.46 0-.833.348-.833.776v1.862h1.667v-1.862c0-.428-.374-.776-.834-.776zM44 8l-2.625 3L44 14H32V8h12z"
                :fill="primaryColor" class="primary-color"
            />
        </g>
    </svg>
</template>
